<template>
  <BaseGridView
    endpoint="v1/ClientContact/GetData"
    :pageTitle="$t('Client Contacts')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
  >
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption } from "../../common/CommonInterfaces";

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "email",
    "firstName",
    "lastName",
    "phone",
    "yearOfBirth",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
      width: 200,
    },
    { field: "email", headerText: instance?.$t("email") },
    { field: "firstName", headerText: instance?.$t("firstName") },
    { field: "lastName", headerText: instance?.$t("lastName") },
    { field: "phone", headerText: instance?.$t("phone") },
    // { field: "role", headerText: instance?.$t("role") },
    { field: "yearOfBirth", headerText: instance?.$t("yearOfBirth") },
  ];
};
</script>
